import Link from "next/link";
import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

export type Item = {
  title: string;
  partialLink: string;
  disabled?: boolean;
};

type Props = {
  items: Item[];
  color?: string;
  separator?: string;
  showActive?: boolean;
  basePath: string;
};

const HelpBreadcrumbs = ({ items, basePath }: Props) => {
  return (
    <div>
      <Breadcrumb>
        {items.map((item: any, i: number) => {
          const partialPath = items
            .slice(0, i + 1)
            .map((e: any) => e.partialLink)
            .join("/");
          return (
            <BreadcrumbItem key={i} active>
              {item.disabled ? (
                item.title
              ) : (
                <Link
                  className={
                    i + 1 === items.length
                      ? "text-darkblue fw-bold"
                      : `text-secondary fw-bold`
                  }
                  href={basePath + "/" + partialPath}
                >
                  {item.title}
                </Link>
              )}
            </BreadcrumbItem>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default HelpBreadcrumbs;
